let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8tqgK"), load("hIzQl"), load("8059b"), load("kjZZD"), load("ffEVr"), load("2IX0x")]).then(() => parcelRequire('jF1MT'));